import { render } from "./htmlParsing.vue?vue&type=template&id=33d6bbb2&scoped=true"
import script from "./htmlParsing.vue?vue&type=script&lang=js"
export * from "./htmlParsing.vue?vue&type=script&lang=js"

import "./htmlParsing.vue?vue&type=style&index=0&id=33d6bbb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33d6bbb2"]])

export default __exports__